import CRUDServiceOperations from "./CRUDServiceOperations";

class KnowledgeService extends CRUDServiceOperations {
  getEntitiesUrl = () => {
    return this.urlFactory.knowledgeItemsUrl();
  };

  postSearchSimilar = (
    entity,
    pageInfo,
    sortInfo,
    callback,
    failureCallback,
    successCallback = undefined
  ) => {
    let url = this.urlFactory.searchSimilarKnowledgeItems();
    if (pageInfo || sortInfo) {
      const urlParams = this.urlFactory.constructPaginationAndFilteringUrlQueries(
        pageInfo,
        sortInfo,
        false
      );
      url += urlParams ? urlParams : "";
    }
    return this.post(url, entity, callback, successCallback, failureCallback);
  };

  search = (pageInfo, sortInfo, callback, failureCallback) => {
    const url = this.urlFactory.searchKnowledgeItems();
    return this.getEntitiesWithParams(
      url,
      pageInfo,
      sortInfo,
      callback,
      failureCallback
    );
  };

  getEntityTopViewOccurrence = (pageInfo, dataCallback, failuteCallback) => {
    const url = this.urlFactory.entityTopViewOccurenceUrl();

    return this.getEntitiesWithParams(
      url,
      pageInfo,
      undefined,
      dataCallback,
      failuteCallback
    );
  };

  getRecommended = (pageInfo, callback, failureCallback) => {
    const url = this.urlFactory.recommendedKnowledgeItems();
    return this.getEntitiesWithParams(
      url,
      pageInfo,
      undefined,
      callback,
      failureCallback
    );
  };
}

export default KnowledgeService;
